// export const ENDPOINT =
//   process.env.NODE_ENV === "development"
//     ? "https://apidev.mostrans.co.id/.graphql_mostrans_career"
//     : "https://api.mostrans.co.id/graphql_career"

// set GENERATE_SOURCEMAP=false

import { agility, mindfullness, novelty, optimistic, responsif, strive, teamwork, trust } from "../assets";

// export const ENDPOINT = "https://api.mostrans.co.id/graphql_career";
export const ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;
// export const ENDPOINT = "http://localhost:4008/graphql"
// export const ENDPOINT = "https://apidev.mostrans.co.id/graphql_mostrans_career";
export const USER_TOKEN_KEY = "USER_TOKEN";

export const BLOB_TYPE = {
  PDF: "application/pdf",
};

export const ROUTE = {
  HOME: "/home",
  NOT_FOUND: "/404",
  LOGIN: "/login",
  DASHBOARD: "/career/home",
  ASSESMENT: "/career/assessment",
};

export const DATE_FORMAT = {
  HURUF: "DD MMMM YYYY",
  HURUF_SHORT: "DD MMM YYYY",
  DATABASE: "YYYY-MM-DD HH:mm:ss",
  DATABASE_SHORT: "YYYY-MM-DD",
  SHORT: "YYYY/MM/DD",
  DATERANGE: "DD/MM/YYYY",
  DATE_FILE: "YYYYMMDDHHmmss",
};

export const OPTION_SOURCE_INFORMATION = [
  { label: "Web Career Mostrans", value: "Web Career Mostrans" },
  { label: "LinkedIn", value: "LinkedIn" },
  { label: "Instagram", value: "Instagram" },
  { label: "Jobstreet", value: "Jobstreet" },
  { label: "Glints", value: "Glints" },
  { label: "Tiktok", value: "Tiktok" },
  { label: "Others", value: "Others" },
];

export const LIST_LEVEL = ["Entry Level", "Middle Level", "Senior Level"];

export const IMAGE_EXTENTIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  // ".doc",
  // ".pdf",
  // "docx",
];
export const DOC_EXTENSIONS = [".doc", ".docx"];
export const PDF_EXTENSIONS = [".pdf"];


export const exampleAvatar = "https://images.vexels.com/media/users/3/129616/isolated/preview/fb517f8913bd99cd48ef00facb4a67c0-businessman-avatar-silhouette-by-vexels.png";


export const BASE_PATH_FIREBASE = ENDPOINT.startsWith("https://api.mostrans")
  ? "mostranscareer"
  : "devmostranscareer";


export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAQw21JarrfuOu1YK6fQspup8EpIuDtJH0",
  authDomain: "mostrans-storage.firebaseapp.com",
  databaseURL: "https://mostrans-storage.firebaseio.com",
  projectId: "mostrans-storage",
  storageBucket: "mostrans-storage.appspot.com",
  messagingSenderId: "108292050379",
  appId: "1:108292050379:web:581945489f5733cabcba4e",
};

export const DETAIL_ARRAY = [
  {
    id: 1,
    title: "Mindfullness",
    desc: "Kesadaran penuh adalah dasar setiap tindakan kami",
    img: mindfullness,
    // img: "https://ik.imagekit.io/mostrans/mindfullness.svg?updatedAt=1699429057340",
    bgColor: "#DF1995",
  },
  {
    id: 2,
    title: "Optimistic",
    desc: "Sikap positif dan percaya diri adalah semangat kami  ",
    img: optimistic,
    // img: "https://ik.imagekit.io/mostrans/optimistic.svg?updatedAt=1699429059070",
    bgColor: "#93328E",
  },
  {
    id: 3,
    title: "Strive for Excellence",
    desc: "Bertekad untuk menjadi yang terbaik",
    img: strive,
    // img: "https://ik.imagekit.io/mostrans/strive%20for%20excellence.svg?updatedAt=1699429060576",
    bgColor: "#00AA13",
  },
  {
    id: 4,
    title: "Trust",
    desc: "Saling percaya dalah perekat di antara kami",
    img: trust,
    // img: "https://ik.imagekit.io/mostrans/trust.svg?updatedAt=1699429060279",
    bgColor: "#00AED6",
  },
  {
    id: 5,
    title: "Responsiveness",
    desc: "Merespon dengan cepat terhadap permintaan pelanggan adalah fokus utama kami",
    img: responsif,
    // img: "https://ik.imagekit.io/mostrans/responsif.svg?updatedAt=1699429059597",
    bgColor: "#FCAA00",
  },
  {
    id: 6,
    title: "Agility",
    desc: "Bergerak lincah, cekatan dan tangkas adalah keunggulan kami",
    img: agility,
    // img: "https://ik.imagekit.io/mostrans/agility.svg?updatedAt=1699429452729",
    bgColor: "#9747FF",
  },
  {
    id: 7,
    title: "Novelty",
    desc: "Inovasi dengan nilai kebaruan tinggi adalah kunci sukses kami",
    img: novelty,
    // img: "https://ik.imagekit.io/mostrans/novelty.svg?updatedAt=1699429059992",
    bgColor: "#E76460",
  },
  {
    id: 8,
    title: "Strong Teamwork",
    desc: "Berkolaborasi dalam kerja tim yang solid adalah panduan hidup kami",
    img: teamwork,
    // img: "https://ik.imagekit.io/mostrans/teamwork.svg?updatedAt=1699429061075",
    bgColor: "#B9A86D",
  },
];